import { ROLE } from '../app/modules/auth'
import { env } from '../env'
import { IRequisite } from '../types'
import { ERequisiteEvent } from '../types/enums'

export const API_URL = env.REACT_APP_API_URL

export const STATUS_COLOR = {
  ['ACTIVE']: 'info',
  ['IN_PROGRESS']: 'primary',
  ['COMPLETED']: 'success',
  ['DECLINED']: 'danger',
  ['EXPIRED']: 'warning',
}

export const ROLE_NAME: { [key: string]: string } = {
  [ROLE.ROLE_ADMIN]: 'Админ',
  [ROLE.ROLE_MANAGER]: 'Менеджер',
  [ROLE.ROLE_SENIOR_CASHIER]: 'Старший кассир',
  [ROLE.ROLE_CASHIER]: 'Кассир',
  [ROLE.ROLE_SENIOR_OPERATOR]: 'Старший оператор',
  [ROLE.ROLE_OPERATOR]: 'Оператор',
  [ROLE.ROLE_MATCHING_OPERATOR]: 'Оператор мэтчинга',
  [ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR]: 'Оператор платежей мерчанта',
  [ROLE.ROLE_MERCHANT_MANAGER]: 'Менеджер мерчантов',
}

export const REQUISITE_EVENT_NAME: { [key: string]: string } = {
  [ERequisiteEvent.CANCEL_RESERVATION]: 'Отмена резервирования',
  [ERequisiteEvent.CREATE_RESERVATION]: 'Начало резервирования',
  [ERequisiteEvent.CREATE]: 'Создание реквизита',
  [ERequisiteEvent.ENABLE_RESERVATION]: 'Включение резервирования',
  [ERequisiteEvent.DISABLE_RESERVATION]: 'Отключение резервирования',
  [ERequisiteEvent.COMPLETE_RESERVATION]: 'Завершение резервирования',
  [ERequisiteEvent.AUTO_CANCEL_RESERVATION]: 'Авто-отмена резервирования',
  [ERequisiteEvent.AUTO_COMPLETE_RESERVATION]: 'Авто-завершение резервирования',
  [ERequisiteEvent.HIDDEN]: 'Скрытие реквизита',
}

export const DEFAULT_REQUISITE_LIST: Array<IRequisite> = []

export const PAYMENT_DIRRECTION_OPTIONS = [
  {
    label: 'Пополнения',
    value: 'PAYMENT',
  },
  {
    label: 'Выплаты',
    value: 'PAYOUT',
  },
]

export const CLIENT_FLAG_OPTIONS = [
  { label: 'white', value: 'white' },
  { label: 'red', value: 'red' },
  { label: 'yellow', value: 'yellow' },
  { label: 'green', value: 'green' },
  { label: 'blue', value: 'blue' },
  { label: 'black', value: 'black' },
  { label: 'orange', value: 'orange' },
  { label: 'purple', value: 'purple' },
]
